import React from "react";

function TrendUp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M15.3999 3.5V7.5C15.3999 7.63261 15.3473 7.75979 15.2535 7.85355C15.1597 7.94732 15.0325 8 14.8999 8C14.7673 8 14.6402 7.94732 14.5464 7.85355C14.4526 7.75979 14.3999 7.63261 14.3999 7.5V4.70687L9.25369 9.85375C9.20725 9.90024 9.15211 9.93712 9.09141 9.96228C9.03071 9.98744 8.96564 10.0004 8.89994 10.0004C8.83423 10.0004 8.76917 9.98744 8.70847 9.96228C8.64777 9.93712 8.59262 9.90024 8.54619 9.85375L6.39994 7.70687L2.25369 11.8538C2.15987 11.9476 2.03262 12.0003 1.89994 12.0003C1.76725 12.0003 1.64001 11.9476 1.54619 11.8538C1.45237 11.7599 1.39966 11.6327 1.39966 11.5C1.39966 11.3673 1.45237 11.2401 1.54619 11.1462L6.04619 6.64625C6.09262 6.59976 6.14777 6.56288 6.20847 6.53772C6.26917 6.51256 6.33423 6.49961 6.39994 6.49961C6.46564 6.49961 6.53071 6.51256 6.59141 6.53772C6.65211 6.56288 6.70725 6.59976 6.75369 6.64625L8.89994 8.79313L13.6931 4H10.8999C10.7673 4 10.6402 3.94732 10.5464 3.85355C10.4526 3.75979 10.3999 3.63261 10.3999 3.5C10.3999 3.36739 10.4526 3.24021 10.5464 3.14645C10.6402 3.05268 10.7673 3 10.8999 3H14.8999C15.0325 3 15.1597 3.05268 15.2535 3.14645C15.3473 3.24021 15.3999 3.36739 15.3999 3.5Z"
        fill="#37B450"
      />
    </svg>
  );
}

export default TrendUp;
